<div *ngIf="inspection?.boxFolderId" style="width: 100%; height: 100vh">
  <app-box-viewer
    [folderId]="inspection.boxFolderId"
    style="width: 100%; height: 100%"
    (onUploadCountChanges)="isUploading = $event > 0"></app-box-viewer>
</div>
